import { Hotel } from './../model/hotel/hotel.model';
import { IAppState } from '../../store';

export const getFutureHotelDecorator = (state: IAppState) => {
    return (hotel: Hotel) => {
      if (hotel.futureBrandInfo) {
        const rebrandingDate = new Date(new Date(hotel.futureBrandInfo.rebrandingDate).setHours(0, 0, 0, 0));
        const checkInDate = state.reservation.stay.checkInDate;
        if (rebrandingDate <= checkInDate) {
          ['brandCode', 'brandName', 'chainCode'].map(key => {
            const value = hotel.futureBrandInfo[key];
            hotel[key] = value;
          });
          hotel.name = hotel.futureBrandInfo.hotelName;
        }
      }
      return hotel;
    }
};



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/delegates/utils.ts